import HttpRequest from './http-request';
import { AxiosResponse } from "axios";

export interface AudioResponse {
  audioUrl: string;
}

const AudioService = () => {
  const { get } = HttpRequest();

  const getAudioData = (url: string): Promise<AxiosResponse<ArrayBuffer>> => {
    return get<ArrayBuffer>(url, 'arraybuffer');
  };

  return {
    getAudioData,
  };
};

export default AudioService;
